// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1trAg","range":"MonthRangeSwitch_range__WueV-","disabled":"MonthRangeSwitch_disabled__3z-Lk"};